export const spinalCase = function() {
  return function(input) {
    return input.toLowerCase().replace(/\_/g, '-');
  };
};